
/*
We have a single flat store of images, mapping a random ID to
an image.

This is separated so that vuex save operators only happen when
an actual change to the image object is made.
*/

export function createImageFromFile(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		let image_data = {
			name: file.name,
			size: file.size,
			type: file.type,
			file: file,
		}
		reader.addEventListener("load", () => {
			let thumb = new Image()
			thumb.onload = () => {
				let canvas = document.createElement("canvas")
				let ctx = canvas.getContext('2d')
				let w = canvas.width = 500
				let h = canvas.height = 500 * (thumb.height / thumb.width)
				ctx.drawImage(thumb, 0, 0, w, h)
				image_data.thumb_src = canvas.toDataURL(file.type)
				resolve(image_data)
			}
			image_data.src = reader.result
			thumb.src = reader.result
		}, false);
		reader.readAsDataURL(file)
	})
}


export default {
	state: {
		images: {}
	},
	mutations: {
		addImage(state, image_data) {
			state.images[image_data.id] = image_data
		},
		
		removeImage(state, image_id) {
			delete state.images[image_id]
		}
	}
}
